"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.createKeyValueStorageFromCookieStorageAdapter = void 0;
var createKeyValueStorageFromCookieStorageAdapter_1 = require("./createKeyValueStorageFromCookieStorageAdapter");
Object.defineProperty(exports, "createKeyValueStorageFromCookieStorageAdapter", { enumerable: true, get: function () { return createKeyValueStorageFromCookieStorageAdapter_1.createKeyValueStorageFromCookieStorageAdapter; } });
